import React, {useState, useEffect} from 'react';
import * as S from './LoginGrow.styles';
import GrowBusiness from './GrowBusiness/GrowBusiness';
import Login from './Login/Login';
import LoginGcc from './LoginGcc/LoginGcc';
import {useSelector, useDispatch} from 'react-redux';
import {useHistory, useLocation} from 'react-router-dom';
import IconSelector from '@ibibo/icon-selector';
import * as _ from 'underscore';
import * as actions from '../../../../../store/actions/index';
import {
  UserNumberSelector,
  errorSelector,
  tokenSelector,
  loginLoadSelector,
  statusSelector,
  directLandingSelector,
  disabledBtnSelector,
  userCountrySelector,
} from '../../../../../store/selectors';
import {
  HOME_PAGE_URL_NEW,
  VERIFY_OTP_NEW_URL,
  NON_EDITABLE_STATUS,
  HOME_PAGE_URL,
} from '../../../../../constants';
import {
  setter,
  getter,
  removeItem,
  hasItem,
} from '../../../../../../../../common/client-side-storage/src/client-side-storage.web';
import {
  redirectToSameWindowWithoutRefresh,
  getUrlWithCrid,
  getCrid,
} from '../../../../../../../myaccount/src/utils/redirectWithCrId';

const LoginGrow = ({displayPop, timeZone, lob, width}) => {
  let blockType = false;
  if (width > 1024) {
    blockType = true;
  }

  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();

  const [errors, setError] = useState({});
  const userNumber = useSelector(UserNumberSelector);
  const userCountry = useSelector(userCountrySelector);
  const token = useSelector(tokenSelector);
  const error = useSelector(errorSelector);
  const status = useSelector(statusSelector);
  const setLoader = useSelector(loginLoadSelector);
  const directLanding = useSelector(directLandingSelector);
  const disabledBtn = useSelector(disabledBtnSelector);

  const successCallback = (t, s, nof) => {
    if (nof) {
      // remove from the local storage when the registration of the user is successful, step {1}
      setter('token', t);
      //history.replace(`${HOME_PAGE_URL_NEW}`);
      history.push(`${VERIFY_OTP_NEW_URL}?crId=${getCrid()}`);
    } else {
      history.push(`${HOME_PAGE_URL}?crId=${getCrid()}`);
    }
  };

  const getQuery = () => {
    const searchQuery = new URLSearchParams(location.search);
    let queryParamsObject = {};

    /*
        ref and cpm are 2 separate use cases, anyone is present, send all the query params to the api call
        */

    if (hasItem('ref')) {
      if (searchQuery.has('ref')) {
        removeItem('ref');
        setter('ref', searchQuery.get('ref'));
      }
      queryParamsObject['ref'] = getter('ref');
    } else if (searchQuery.has('ref')) {
      // dict of all query params .. since location.query is deprecated
      queryParamsObject = {...queryParamsObject, ...Object.fromEntries(searchQuery)};

      // just another step in case ref related query params are sent
      //to persist if ref is present on landing and is not present in local storage or present/ and updatingg
      if (searchQuery.has('ref')) {
        // localstorage access after window checks
        setter('ref', searchQuery.get('ref'));
      }
      // case to fetch from localstorage, if the user lands on the home page for the second time directly
    }

    if (searchQuery.has('cmp')) {
      // dict of all query params .. since location.query is deprecated
      queryParamsObject = {
        ...Object.fromEntries(searchQuery),
        cmp: getter('cmp'),
        ...queryParamsObject,
      };

      // case to fetch from localstorage, if the user lands on the home page for the second time directly
    } else if (hasItem('cmp')) {
      queryParamsObject['cmp'] = getter('cmp');
    }

    return queryParamsObject;
  };

  const submitData = data => {
    // if (NON_EDITABLE_STATUS.indexOf(status) !== -1) {
    //     successCallback(token ? token : '', status);
    //     return;
    // }
    // if(data.mobile === userNumber.mobile && data.country_code === userNumber.countryCode){
    //     successCallback(token ? token : '', status);
    //     return;
    // }else{
    /*
            Mainly to handle the case where the user lands on the home page from a link from a business agent
        
            References for tagging agenet's signup to business agents. Usually we get it when user lands from the shared referal
            links.
                >>Two types :
            Ref or anything related to that - should be persisted across window closes
            cpm, and anything related to that - should just be forwarded
            */

    let fd = new FormData();
    let additionalQueryData = getQuery();

    // spread both the values -- original form data and the new additional fields which should be sent to register api
    // combine the objets
    let combinedFormData = {...data, ...additionalQueryData};
    for (const key in combinedFormData) {
      fd.append(key, combinedFormData[key]);
    }
    dispatch(actions.getMobileOtp(data, fd, successCallback, userCountry));
    // }
  };

  let LoginBlock = (
    <Login
      userNumber={userNumber}
      onSubmit={submitData}
      apiError={error}
      status={status}
      setLoader={setLoader}
      directLanding={directLanding}
      btnDisable={disabledBtn}
    />
  );

  let LoginGccBlock = (
    <LoginGcc
      userNumber={userNumber}
      onSubmit={submitData}
      apiError={error}
      status={status}
      setLoader={setLoader}
      directLanding={directLanding}
      btnDisable={disabledBtn}
    />
  );

  if (!width) {
    LoginBlock = null;
    LoginGccBlock = null;
  }

  return (
    <S.LoginGrowMainWrap>
      {blockType ? (
        <>
          <GrowBusiness timeZone={timeZone} lob={lob} />
          {userCountry ? LoginGccBlock : LoginBlock}
        </>
      ) : (
        <>
          {userCountry ? LoginGccBlock : LoginBlock}
          <GrowBusiness timeZone={timeZone} lob={lob} />
        </>
      )}
    </S.LoginGrowMainWrap>
  );
};

export default LoginGrow;
